import { render, staticRenderFns } from "./BenefitsTeamManagerModal.vue?vue&type=template&id=1b5a0fe5&scoped=true&"
import script from "./BenefitsTeamManagerModal.vue?vue&type=script&lang=ts&"
export * from "./BenefitsTeamManagerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a0fe5",
  null
  
)

export default component.exports